<template >
  <CContainer
    class="d-flex bg-custom align-items-center justify-content-center min-vw-100 min-vh-100"
  >
    <CRow class="width-custom justify-content-center">
      <CCol md="12" lg="12">
        <CCard class="p-4 color-custom">
          <CCardBody>
            <CForm class="d-flex flex-column justify-content-center">
              <div class="mb-2 border-custom align-self-center">
                <CImg :src="image" align="center" width="120" height="120" class="m-0" />
              </div>

              <!-- <CImg
                :src="image"
                align="center"
                width="150"
                height="150"
                class="mb-2 border-custom"
              />-->
              <h2 class="text-center">Recuperar contraseña</h2>
              <CAlert v-if="error" color="danger">{{ error }}</CAlert>
              <CAlert v-if="success" color="success">{{ success }}</CAlert>
              <CInput
                :value.sync="claveEmpresa"
                class="mt-3"
                placeholder="Código de empresa"
                autocomplete="company"
              >
                <template #prepend-content>
                  <CIcon name="cil-industry" />
                </template>
              </CInput>
              <CInput
                :value.sync="email"
                type="email"
                placeholder="Correo electrónico"
                autocomplete="username email"
              >
                <template #prepend-content>
                  <CIcon name="cil-user" />
                </template>
              </CInput>

              <CRow>
                <CCol col="12" class="text-left">
                  <router-link class="btn-custom-width" :to="{ name: 'Login'}">
                    <CButton color="link" class="px-0 link-underline">Acceder a mi cuenta</CButton>
                  </router-link>
                </CCol>
              </CRow>
              <div v-if="isLoading" class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow d-flex align-items-center">
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                </div>
              </div>
              <CRow class="px-3 mt-3" alignHorizontal="center">
                <!-- <router-link class="btn-custom-width" :to="{ name: 'Home'}"> -->
                <CButton @click="getRecuperar()" class="btn-custom-width" color="primary">Enviar</CButton>
                <!-- </router-link> -->
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Cambio de contraseña"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
    <CModal
      size="sm"
      title="Cambio de contraseña"
      :centered="true"
      color="primary"
      :show.sync="successModal"
    >{{ success }}</CModal>
  </CContainer>
</template>

<script>
import logo from "../assets/images/Logo-Vertical-Blanco.png";

export default {
  name: "Recovery",
  data() {
    return {
      image: logo,
      claveEmpresa: "",
      email: "",
      error: "",
      warningModal: false,
      successModal: false,
      success: "",
      isLoading: false
    };
  },

  // mixins: [validationMixin],
  // validations: {
  //   claveEmpresa: {
  //     required
  //   },
  //   email: {
  //     required,
  //     email
  //   },
  //   contrasena: {
  //     required
  //   }
  // },

  // computed: {
  //   isValidClave() {
  //     return !this.$v.claveEmpresa.$invalid;
  //   },
  //   isValidEmail() {
  //     return !this.$v.email.$invalid;
  //   }
  // },

  methods: {
    getRecuperar() {
      // this.validateRecuperar();

      // this.$store.commit("SET_CLAVEEMPRESA", {
      //   clave_empresa: this.claveEmpresa
      // });
      this.isLoading = true;

      this.$store
        .dispatch("recoverPassword", {
          clave_empresa: this.claveEmpresa,
          correo: this.email
        })
        .then(() => {
          this.isLoading = false;
          this.error = "";
          this.success = "Correo de recuperación enviado";
          // this.successModal = true;
          this.resetCambio();
        })
        .catch(rej => {
          this.isLoading = false;

          // this.error = rej.message;
          rej
            ? (this.error = rej.data.message)
            : (this.error = "El campo de clave de código es incorrecto.");
          // this.warningModal = true;
          // this.error = rej.message;
          // this.warningModal = true;
        });
    },
    // checkIfValid(fieldName) {
    //   const field = this.$v[fieldName];
    //   if (!field.$dirty) {
    //     return null;
    //   }
    //   return !(field.$invalid || field.$model === "");
    // },
    // validateRecuperar() {
    //   this.$v.claveEmpresa.$touch();
    //   this.$v.email.$touch();
    // },
    resetCambio() {
      this.claveEmpresa = "";
      this.email = "";
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.bg-custom {
  background-color: #3c4b64 !important;
  margin: 0 !important;
}
.color-custom {
  background-color: rgba(255, 255, 255, 1);
}
.border-custom {
  border-radius: 50% !important;
  background-color: #3c4b64 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  width: 160px;
}
.width-custom {
  width: 450px;
}
.btn-custom-width {
  width: 100%;
}
.link-underline {
  text-decoration: underline;
}
</style>
